var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-color":"#3fdbbf","inactive-color":"#989aae"},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }